import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { LeanTerm } from '../../entities/control-tables/lean-term';


export class TermRequest extends BaseRequest {
  term : LeanTerm;
  constructor(userInfo : UserInfo){
    super(userInfo);
    this.term = new LeanTerm();
  }
}